module.exports = __webpack_public_path__ + "static/media/caramel.92a885e5.jpg";